import {
  SELECT_RESOURCE_TYPE,
  SELECT_BUSINESS_CODE,
  FETCH_BUSINESS_CODES_SUCCESS,
  FETCH_BUSINESS_CODES_FAILURE,
  FETCH_SINGLE_PROVISION_QUALITY,
  FETCH_SINGLE_PROVISION_QUALITY_SUCCESS,
  FETCH_SINGLE_PROVISION_QUALITY_FAILURE,
} from './types';

import initialState from './provisionQualitySingle.initialState';

const provisionQualitySingleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_RESOURCE_TYPE:
      return {
        ...state,
        resourceType: action.resourceType,
      };
    case SELECT_BUSINESS_CODE:
      return {
        ...state,
        businessCode: action.businessCode,
      };
    case FETCH_SINGLE_PROVISION_QUALITY:
      return {
        ...state,
        provisionQualityLoading: true,
      };
    case FETCH_SINGLE_PROVISION_QUALITY_SUCCESS:
      return {
        ...state,
        provisionQualityLoading: false,
        provisionQuality: {
          ...initialState.provisionQuality,
          ...action.result.provisionQuality,
        },
        lastRunDate: (action.result.provisionQuality && action.result.provisionQuality.lastRunDate) || '',
        allProvisions: action.result.allProvisions,
        processedSuccessfully: action.result.processedSuccessfully,
        trialBalancesNotReceived: action.result.trialBalancesNotReceived,
        trialBalancesWithErrors: action.result.trialBalancesWithErrors,
        calculationsWithErrors: action.result.calculationsWithErrors,
        otherErrors: action.result.otherErrors,
        journals: action.result.journals,
        localJournals: action.result.localJournals,
        lastFetch: new Date(),
      };
    case FETCH_SINGLE_PROVISION_QUALITY_FAILURE:
      return {
        ...state,
        provisionQualityLoading: false,
        provisionQuality: initialState.provisionQuality,
        lastRunDate: '',
        allProvisions: initialState.allProvisions,
        processedSuccessfully: initialState.processedSuccessfully,
        trialBalancesNotReceived: initialState.trialBalancesNotReceived,
        trialBalancesWithErrors: initialState.trialBalancesWithErrors,
        calculationsWithErrors: initialState.calculationsWithErrors,
        otherErrors: initialState.otherErrors,
        journals: initialState.journals,
        localJournals: initialState.localJournals,
        lastFetch: new Date(),
      };
    case FETCH_BUSINESS_CODES_SUCCESS:
      return {
        ...state,
        businessCode: (state.businessCode
            && action.businessCodes.find(({ businessCode }) => state.businessCode.businessCode === businessCode))
          || initialState.businessCode,
        businessCodes: action.businessCodes || initialState.businessCodes,
      };
    case FETCH_BUSINESS_CODES_FAILURE:
      return {
        ...state,
        businessCodes: initialState.businessCodes,
      };
    default:
      return state;
  }
};

export default provisionQualitySingleReducer;
